import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function logUserActivity(userId, action, details = "") {
  try {
    const activityRef = collection(db, "users", userId, "activityLogs");
    await addDoc(activityRef, {
      action,
      details,
      timestamp: serverTimestamp(),
    });
  } catch (error) {
    console.error("🔥 Failed to log user activity:", error);
  }
}
